import React from 'react';
import { useViewlogies } from 'context';
import { FormattedMessage } from 'react-intl';
import Card from './Card';
import './obituary.scss';
import obituaryImg from 'assets/obituary.jpg';

const Obituary = () => {
    const {
        event: { obituaryUrl, firstName, lastName, color, isLoggedIn },
    } = useViewlogies();

    //  if (!isLoggedIn) {
    //     return null;
    // }

    let obituary = null;
    if (obituaryUrl) {
        const externalObituaryUrl =
            obituaryUrl.indexOf('http://') === 0 || obituaryUrl.indexOf('https://') === 0
                ? obituaryUrl
                : `//${obituaryUrl}`;

        obituary = (
            <Card
                imageSrc={obituaryImg}
                color={color}
                title={
                    <FormattedMessage
                        id="features.Viewlogy.Obituary.title"
                        defaultMessage="Memorialize Your Loved One"
                    />
                }
                description={
                    <FormattedMessage
                        id="features.Viewlogy.Obituary.description"
                        defaultMessage="Read the obituary, add your own photos, and spend additional time to honor the life of {1}."
                        values={{ 1: `${firstName} ${lastName}` }}
                    />
                }
                link={externalObituaryUrl}
                linkText={
                    <FormattedMessage
                        id="features.Viewlogy.Obituary.link"
                        // defaultMessage="Visit Remembrance Page"
                        defaultMessage="Visit Obituary"
                        values={{ 1: `${firstName} ${lastName}` }}
                    />
                }
            />
        );
    }

    return <div className="obituary">{obituary}</div>;
};

export default Obituary;
